// TODO: Remove or extend when real API is implemented
export const ENROLMENT_FORM_SECTIONS = [
  {
    id: 'applicant-details',
    label: 'Applicant details',
    routeName: 'enrolment-applicant-details',
    sectionNumber: 1,
  },
  {
    id: 'contact-household',
    label: 'Contact and household',
    routeName: 'enrolment-contact-household',
    sectionNumber: 2,
  },
  {
    id: 'employment-education',
    label: 'Employment and education',
    routeName: 'enrolment-employment-education',
    sectionNumber: 3,
  },
  {
    id: 'residency-and-id',
    label: 'Residency and ID information',
    routeName: 'enrolment-residency-and-id',
    sectionNumber: 4,
  },
  {
    id: 'marketing-options',
    label: 'Marketing options',
    routeName: 'enrolment-marketing-options',
    sectionNumber: 5,
  },
  {
    id: 'sign-and-confirm',
    label: 'Sign and confirm',
    routeName: 'enrolment-sign-and-confirm',
    sectionNumber: 6,
  },
];

export const ENROLMENT_FORM_SECTION_COUNT = ENROLMENT_FORM_SECTIONS.length;

export function getEnrolmentSection(sectionId) {
  return ENROLMENT_FORM_SECTIONS.find(section => section.id === sectionId);
}

export function getEnrolmentSectionHeading(sectionId) {
  return getEnrolmentSection(sectionId).label;
}

export function getEnrolmentSectionProgressLabel(sectionId) {
  const section = getEnrolmentSection(sectionId);
  return `Section ${section.sectionNumber} of ${ENROLMENT_FORM_SECTION_COUNT}`;
}

export function getAdjacentEnrolmentSection(sectionId, direction) {
  const currentIndex = ENROLMENT_FORM_SECTIONS.findIndex(section => section.id === sectionId);

  if (currentIndex === -1) {
    return null;
  }

  const adjacentIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
  return ENROLMENT_FORM_SECTIONS[adjacentIndex] || null;
}
